import { Viewer } from './Viewer';

export default Viewer;
